import React, { ReactElement } from 'react';
import { PebbleWarning } from '@ds/icons';
import { ContainerLayout } from 'layouts';
import { TranslationContext } from '@ds/react-utils';
import { HeaderIconContainer } from 'components/shared';

const SessionTimeoutPage = (): ReactElement => {
    const translate = React.useContext(TranslationContext);

    return (
        <ContainerLayout>
            <ContainerLayout.Header>
                <HeaderIconContainer data-qa="verify-session-timeout-error-picto">
                    <PebbleWarning width="48px" height="48px" viewBox="1 1 22 22" />
                </HeaderIconContainer>
                <ContainerLayout.Header.Title titleDataQa="verify-session-timeout-title" title={translate('Please start again')} />
            </ContainerLayout.Header>

            <ContainerLayout.InnerContent dataQa="verify-session-timeout-content">
                <p>{translate('For your security, we closed this unattended session.')}</p>
            </ContainerLayout.InnerContent>
        </ContainerLayout>
    );
};

export default SessionTimeoutPage;
